// Submit a form to Netlify Forms from the React app.
// Forms are registered from public/__forms.html, and we POST to that static file
// so the SPA "/*" rewrite can't get in the way.
const encode = (data) =>
    Object.keys(data)
        .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(data[k] ?? ""))
        .join("&");

export async function submitNetlifyForm(formName, data) {
    const res = await fetch("/__forms.html", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: encode({ "form-name": formName, ...data }),
    });
    if (!res.ok) {
        // Shows in the browser console to help diagnose (404 = form detection off or form not registered)
        console.error(`[Netlify Forms] "${formName}" submit failed: HTTP ${res.status}`);
        throw new Error(`Form submit failed: ${res.status}`);
    }
    return true;
}
